import classNames from "classnames";
import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { webAndMobileDetailsURL, webAndMobileTOU, webAndMobileTOUGeneral } from "../../../constants/urls";
import { StateContext } from "../../../context/stateContext";
import { useFetch } from "../../../hooks/useFetch";
import { IURLAssetReference } from "../../../interfaces/urlAssetReference";
import utils from "../../../utils/helperFunction";
import ParentFragmentHTML from "../../lib/ParentFragmentHTML";
import styles from "./BamTou.module.scss";

interface TOUDataType {
  urlAssetReferences: IURLAssetReference[];
  path: string;
}

const { getStateName } = utils;

const BamTou = () => {
  const { cidmUrl, stateUSACode, languageCode } = useContext(StateContext);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  searchParams.set("name", "privacy-statement");
  const URL = `${cidmUrl}${webAndMobileDetailsURL(getStateName(stateUSACode), languageCode)}${webAndMobileTOU(
    languageCode
  )}${getStateName(stateUSACode)}-${webAndMobileTOUGeneral}`;

  const { data, loading } = useFetch<TOUDataType>(URL);

  return (
    <>
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <div
        data-testid="tou-scroll-view"
        className={classNames("overflow-y-auto smooth-scroll", styles["webAndMobileTou--Paragraphs"])}
      >
        {!loading && <ParentFragmentHTML data={data?.urlAssetReferences} />}
      </div>
    </>
  );
};
export default BamTou;
